(() => {
  if (window.__pkmEchoBisBound) return;
  window.__pkmEchoBisBound = true;

  const TARGET_PRODUCT_ID = '11193141920086';
  const TARGET_VARIANT_ID = '55046078202198';
  const PUBLIC_COMPANY_ID = 'V9j95P';
  const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${PUBLIC_COMPANY_ID}`;

  const closestRoot = (target) => target?.closest?.('[data-pkm-echo-bis]');
  const setVariantVisibility = (form, variant) => {
    if (form?.querySelector('input[name="product-id"]')?.value !== TARGET_PRODUCT_ID) return;

    const productShell = form.closest('product-rerender');
    const root = productShell?.querySelector('[data-pkm-echo-bis]')
      || document.querySelector(`[data-pkm-echo-bis][data-product-id="${TARGET_PRODUCT_ID}"]`);
    if (!root) return;

    root.hidden = String(variant?.id || '') !== TARGET_VARIANT_ID || variant?.available !== false;
  };

  document.documentElement.dataset.pkmEchoBisReady = 'true';

  document.addEventListener('variant:change', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest?.('form');
    setVariantVisibility(form, event.detail?.variant);
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-pkm-echo-bis-open]');
    if (openButton) {
      const root = closestRoot(openButton);
      if (root?.dataset.productId !== TARGET_PRODUCT_ID || root?.dataset.variantId !== TARGET_VARIANT_ID) return;
      root.querySelector('[data-pkm-echo-bis-dialog]')?.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-pkm-echo-bis-close]');
    if (closeButton) closestRoot(closeButton)?.querySelector('[data-pkm-echo-bis-dialog]')?.close();
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest?.('[data-pkm-echo-bis-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-pkm-echo-bis-form]');
    if (!form) return;
    event.preventDefault();

    const root = closestRoot(form);
    if (root?.dataset.productId !== TARGET_PRODUCT_ID || root?.dataset.variantId !== TARGET_VARIANT_ID) return;

    const email = new FormData(form).get('email')?.toString().trim();
    if (!email || !form.reportValidity()) return;

    const submit = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-pkm-echo-bis-status]');
    submit.disabled = true;
    status.textContent = '';
    status.dataset.state = 'pending';

    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2026-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${TARGET_VARIANT_ID}`,
                },
              },
            },
          },
        }),
      });

      if (!response.ok) throw new Error(`Back-in-stock subscription failed (${response.status})`);
      form.reset();
      status.dataset.state = 'success';
      status.textContent = status.dataset.success;
    } catch (error) {
      console.error('Echo Drop back-in-stock signup failed.', error);
      status.dataset.state = 'error';
      status.textContent = status.dataset.error;
    } finally {
      submit.disabled = false;
    }
  });
})();
